import { useAuth } from '@/contexts/AuthContext';

/**
 * Voice Studio is in beta. Access mirrors the `voice-proxy` edge function gate:
 * PODGO platform admins, plus individual users staff have flagged into the beta
 * via `profiles.voice_studio_enabled` (admin UserDetail toggle).
 */
export function useVoiceStudioAccess(): boolean {
  const { hasRole, profile } = useAuth();
  return hasRole('admin') || profile?.voice_studio_enabled === true;
}
